import { html } from "lit";
import { HomepageSlider } from "../../partial-templates/slider/slider.stories";
import { Default as ProductHighlightSliderTemplate } from "../../../components/product-highlight-slider/product-highlight-slider.stories"; // ToDo: check if multirow styles are still required (seem to be removed/not maintained during the Swiper Update in ux.ui https://gitlab.com/TRUMPF-corp/trumpf-ux/features/com.trumpf.ux.ui-core/-/merge_requests/499)
import { NewsBlockTemplate } from "./homepage-blocks/news-block.template";
import { Grid as TeaserCounter } from "../../../components/teaser-counter/teaser-counter.stories";
import { Template as Headline } from "../../../shared/headline";
import { DoubleTeaserTileTemplate as DoubleTeaserTile } from "../../partial-templates/double-teaser-tile/double-teaser-tile.templates";
import { SectionsSlider } from "../../partial-templates/slider/slider.stories";
import { successStoriesSlider } from "../../partial-templates/slider/slider.stories";
import { TemplateMultipleItems as LocationBlock } from "../../../components/location-block/location-block.templates";
import { NewsroomBlockTemplate } from "./homepage-blocks/newsroom-block.template";

TeaserCounter.args = {
    title: "Mio. Euro",
    subtitle: "Aaufwendungen für Forschung",
    decimalSeparator: ".",
    decimalsCount: "2",
    noAnimation: "false",
    number: 377.4,
    prefixValue: "",
    suffixValue: "",
    thousandsSeparator: ",",
    gridItems: 3,
};

export const HomepageTemplate = (homepageStoryArgs) => html`
    ${homepageStoryArgs.withInfoBanner
        ? html` <div class="ux-t-container-full">
              <ux-info-banner icon="circle-info" type="info">
                  <p>
                      Updates on the platform: Lorem ipsum kmflkw gkejgoerno
                      gkernoger goerngoe ognreo gone genjng
                  </p>
              </ux-info-banner>
          </div>`
        : ""}
    <div class="ux-t-container-full ux-u-mb-fluid-m">${HomepageSlider()}</div>
    ${!homepageStoryArgs.withNewsroomBlock
        ? html`
              <div class="ux-t-container ux-u-mb-fluid-m">
                  ${NewsBlockTemplate()}
              </div>
          `
        : html`
              <div
                  class="ux-t-container-full ux-u-mb-fluid-xxs ux-u-overflow-hidden"
              >
                  ${NewsroomBlockTemplate({ withInfoTeaser: true })}
              </div>
          `}

    <div class="ux-t-container-full ux-u-mb-fluid-xxs ux-u-overflow-hidden">
        ${ProductHighlightSliderTemplate(homepageStoryArgs.noHiglightSlider)}
    </div>
    <div class="ux-t-container ux-u-mb-fluid-m">
        ${Headline()} ${TeaserCounter({ ...TeaserCounter.args })}
    </div>
    <div class="ux-t-container-full ux-u-mb-fluid-m">${DoubleTeaserTile()}</div>
    <div class="ux-t-container-full ux-u-mb-fluid-m">
        ${successStoriesSlider()}
    </div>
    <div class="ux-t-container-full ux-u-mb-fluid-m">
        ${SectionsSlider(homepageStoryArgs.sectionsSliderWithHeadline)}
    </div>
    <div class="ux-t-container-full">${LocationBlock()}</div>
`;
